import React from 'react';
import { ContentBoxContainer, ContentBoxText, ContentBoxFigure, Spacer, FaqQuestions, FaqAnswers, Query, PenlySeo } from 'components';
import FAQ_ENTRIES_QUERY from 'queries/faq/faqEntries';
import { mediaQueries, fromTablethoriMediaQuery } from 'utils/MediaQueriesDeprecated';

export default function OfteStilledeSpoergsmaal() {
    const title = 'Ofte stillede spørgsmål';
    const description = 'Få svar på de mest stillede spørgsmål om Penly og vores værktøjer.';
    const image = { url: '/static/gfx/content/penly-content-5.jpg' };
    const categories = ['Penly', 'PensionsTjek', 'Penly Play', 'Sikkerhed & Data', 'Services', 'Partnere'];
    const categoriesAndEntries = [];

    const initializeCategories = entries => {
        if (categoriesAndEntries.length === 0) {
            categories.forEach(category => {
                const faqEntries = entries.filter(x => x.blog_category?.title === category);

                if (faqEntries?.length > 0) {
                    categoriesAndEntries.push({
                        name: category,
                        entries: faqEntries,
                    });
                }
            });
        }

        return categoriesAndEntries;
    };

    const fromTablethori = mediaQueries(fromTablethoriMediaQuery);

    return (
        <>
            <PenlySeo title={ title } description={ description } image={ image } />
            <ContentBoxContainer className="mobileflip flat">
                <ContentBoxText>
                    <h1 className="nomb">{ title }</h1>
                    <h4 className="lowerCase">{ description }</h4>
                </ContentBoxText>
                { fromTablethori && <ContentBoxFigure className="brtl topSpace" figure={ image.url }></ContentBoxFigure> }
            </ContentBoxContainer>
            { fromTablethori && <Spacer /> }

            <Query query={ FAQ_ENTRIES_QUERY }>
                { ({ data }) => (
                    <>
                        <FaqQuestions categoriesAndEntries={ initializeCategories(data.faqEntries) } />
                        <Spacer />
                        <FaqAnswers categoriesAndEntries={ initializeCategories(data.faqEntries) } />
                    </>
                ) }
            </Query>
        </>
    );
}
